import {OrderStatus, PaymentStatus, PaymentType} from "../enums/enums";


export const orderSchema = () => {
    return(
        {
            paymentType: {
                type: 'select',
                label: 'Payment Type',
                options: PaymentType,
                enums:true,
            },
            paymentStatus: {
                type: 'select',
                label: 'Payment Status',
                options: PaymentStatus,
                enums:true,
            },
            orderStatus: {
                type: 'select',
                label: 'Order Status',
                options: OrderStatus,
                enums:true,
            },
        }
    )
}

